import RouteView from '@/layouts/RouteView'

export default {
  path: '/app-mana/index',
  name: 'App.Search',
  meta: { icon: 'shop', title: '业务平台管理', bread: true },
  component: () =>
    import('@/views/app-mana/search/index.vue'),
}
